import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Country } from "../models/country.model";
import { GraphQLService } from "./graphql.service";
import { HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable()
export class CountryService extends GraphQLService<Country> {

  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  deliverable(): Observable<Country[]> {
    return this.findAll(`{ countries { id iso eu americas printableName synonyms current ustidPattern } }`)
  }

}
